import React from "react";
import { motion } from "framer-motion";
import { STATS } from "../../data/content";
import { scrollToId as scrollTo } from "../../lib/scroll";
import inizioImg from "../../assets/inizio.jpg";

export const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen flex flex-col justify-center bg-cream overflow-hidden pt-28 pb-12"
    >
      {/* background court lines */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.06]">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60vh] h-[60vh] rounded-full border-[3px] border-navy" />
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[3px] h-full bg-navy" />
      </div>

      <div className="relative mx-auto max-w-[1400px] w-full px-4 md:px-8 lg:px-12 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 z-10">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15, duration: 0.6 }}
            className="font-sub uppercase tracking-[0.3em] text-court font-bold text-sm mb-5"
            data-testid="hero-kicker"
          >
            Tradizione | Impegno | Solidarietà
          </motion.p>

          <h1 className="font-heading uppercase leading-[0.92] text-navy text-6xl sm:text-7xl md:text-8xl lg:text-9xl tracking-tighter">
            <span className="hero-mask-line">
              <motion.span
                initial={{ y: "110%" }}
                animate={{ y: "0%" }}
                transition={{ delay: 0.25, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                className="block"
              >
                Polisportiva
              </motion.span>
            </span>
            <span className="hero-mask-line">
              <motion.span
                initial={{ y: "110%" }}
                animate={{ y: "0%" }}
                transition={{ delay: 0.38, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                className="block text-royal"
              >
                Tricesimo
              </motion.span>
            </span>
          </h1>

          <p
            className="reveal mt-8 max-w-xl font-body text-lg md:text-xl text-navy/70 leading-relaxed"
            style={{ animationDelay: "0.45s" }}
            data-testid="hero-subtitle"
          >
            Dal 1968 coltiviamo la passione per la pallacanestro nel cuore del Friuli.
            Dal minibasket alla prima squadra, cresciamo insieme, un canestro alla volta.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <button
              data-testid="hero-cta-primary"
              onClick={() => scrollTo("iscriversi")}
              className="bg-royal text-white rounded-none px-8 py-4 font-sub font-bold uppercase tracking-widest hover:bg-court transition-colors duration-300 shadow-hard"
            >
              Vieni a giocare
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={() => scrollTo("squadre")}
              className="border-2 border-navy text-navy bg-transparent rounded-none px-8 py-4 font-sub font-bold uppercase tracking-widest hover:bg-navy hover:text-white transition-colors duration-300"
            >
              Le nostre squadre
            </button>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative reveal" style={{ animationDelay: "0.3s" }}>
            <img
              src={inizioImg}
              alt="La squadra APT 1968 Tricesimo esulta insieme"
              className="w-full h-[420px] lg:h-[560px] object-cover border-4 border-navy"
              data-testid="hero-image"
            />
            <div className="absolute -bottom-6 -left-6 bg-gold text-navy font-heading text-3xl md:text-4xl px-6 py-3 border-4 border-navy shadow-hard hidden sm:block">
              DAL 1968
            </div>
          </div>
        </div>
      </div>

      {/* stats bar */}
      <div
        className="reveal relative mx-auto max-w-[1400px] w-full px-4 md:px-8 lg:px-12 mt-16"
        style={{ animationDelay: "0.6s" }}
      >
        <div className="grid grid-cols-2 md:grid-cols-4 border-t border-l border-navy/20">
          {STATS.map((s) => (
            <div key={s.label} data-testid={`stat-${s.label}`} className="border-b border-r border-navy/20 p-6">
              <div className="font-heading text-4xl md:text-5xl text-royal">{s.value}</div>
              <div className="font-sub uppercase tracking-wider text-xs md:text-sm text-navy/60 mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
